(function () {
    'use strict';

    var $           = require('jquery');
    var $tabs       = $('.tabs');
    var selected    = 'selected';

    if ($tabs.length > 0) {

        $tabs.each(function () {

            var $this   = $(this);
            var $tabNav = $this.find('.tab-nav');
            var $tab    = $this.find('.tab');

            $tabNav.on('click', 'a', function (ev) {
                ev.preventDefault();

                var $this   = $(this);
                var href    = $this.attr('href');

                $tabNav.find('li').removeClass(selected);
                $this.parent().addClass(selected);

                $tab.removeClass(selected);
                $(href).addClass(selected);

            });

        });

    }

})();